export const DELETE_INSTANT_UPLOAD_LOADING = "delete/instant/upload/loading"
export const DELETE_INSTANT_UPLOAD_SUCCESS = "delete/instant/upload/success"
export const DELETE_INSTANT_UPLOAD_ERROR = "delete/instant/upload/error"

export const DELETE_INSTANT_VIDEO_LOADING = "delete/instant/video/loading"
export const DELETE_INSTANT_VIDEO_SUCCESS = "delete/instant/video/success"
export const DELETE_INSTANT_VIDEO_ERROR = "delete/instant/video/error"